// extracted by mini-css-extract-plugin
export var activeItem = "rlCc0";
export var blogListing = "UCr1W";
export var cardWrap = "_4jvML";
export var contactIcon = "jjAqg";
export var contactLabel = "U4psz";
export var contactLink = "ZrH5i";
export var personItem = "UPTRz";
export var sectionSpacing = "NDepB";
export var socialWrapper = "jT1Nc";